var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevertApprover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C11.7565 0 7.68687 1.68571 4.68629 4.68629C1.68571 7.68687 0 11.7565 0 16C0 24.8353 7.16308 32 16 32C24.8353 32 32 24.8353 32 16C32 7.16308 24.8353 0 16 0ZM23.5126 21.6238C21.6615 19.6841 19.5512 18.647 15.1598 18.647V21.5188C15.1591 21.6435 15.1219 21.7653 15.0528 21.8692C14.9838 21.9731 14.8859 22.0545 14.7712 22.1035C14.6564 22.1525 14.5299 22.1669 14.4071 22.145C14.2843 22.123 14.1706 22.0656 14.08 21.9799L7.58154 15.8457C7.51874 15.7868 7.4687 15.7156 7.43448 15.6366C7.40027 15.5576 7.38262 15.4724 7.38262 15.3863C7.38262 15.3001 7.40027 15.2149 7.43448 15.1359C7.4687 15.0569 7.51874 14.9857 7.58154 14.9268L14.0767 8.79097C14.1674 8.70461 14.2814 8.64674 14.4046 8.62453C14.5278 8.60231 14.6548 8.61672 14.7699 8.66598C14.885 8.71523 14.9832 8.79717 15.0522 8.90165C15.1212 9.00612 15.158 9.12854 15.1582 9.25374V12.1239C21.9832 12.1239 24.1904 16.4037 24.6105 21.1315C24.6663 21.7239 23.9278 22.057 23.5126 21.6238Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevertApprover);
export default __webpack_public_path__ + "static/media/revertApprover.f26eb7865576b88c968b6362ca57147d.svg";
export { ForwardRef as ReactComponent };